/* Subtle one-time fade-up for [data-mbg-reveal] sections (About page).
   No-ops entirely under prefers-reduced-motion or without
   IntersectionObserver support — content is already visible either way,
   this only ever adds motion, never hides content. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  if (!('IntersectionObserver' in window)) {
    return;
  }

  var targets = document.querySelectorAll('[data-mbg-reveal]');
  if (!targets.length) {
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mbg-is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  targets.forEach(function (target) {
    observer.observe(target);
  });
})();
